import React, { useState } from 'react';
/* eslint-disable import/no-unresolved */
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard, A11y } from 'swiper/modules';
import 'swiper/css/bundle';
import { bpProductGallery } from '../../Carousel/breakpoints';
import { ContentfulAccessoryVariant } from '../../../ContentfulTypes';

import MissingProductImage from '../../Carousel/ProductCard/MissingProductImage';
import {
  ImageGallery,
  ImagesContainer,
  PrimaryImageContainer,
  ThumbnailImageContainer,
  PrimaryImage,
  ImageWrapper,
  ImageWrap,
  SecondaryImage,
  MobileImagesContainer,
  MobileImageWrap,
  MobileSecondaryImage,
  Carousel,
} from './styles';

interface Props {
  variant: ContentfulAccessoryVariant;
}

const ProductGallery = ({ variant }: Props) => {
  const { imageLinksList, accessoryColour } = variant;
  const [primaryImage, setPrimaryImage] = useState(0);

  return (
    <ImageGallery>
      <MobileImagesContainer>
        {imageLinksList ? (
          <Carousel>
            <Swiper
              tabIndex="0"
              speed={1000}
              breakpoints={bpProductGallery}
              navigation
              pagination={{
                clickable: true,
              }}
              a11y={{
                slideRole: 'group',
                enabled: true,
              }}
              allowTouchMove
              keyboard
              modules={[Navigation, Pagination, Keyboard, A11y]}
              className="swiper"
            >
              {imageLinksList?.map((image, index) => (
                <SwiperSlide key={image}>
                  <MobileImageWrap>
                    <MobileSecondaryImage
                      src={image}
                      fetchPriority={index === 0 ? "high" : "low"}
                      loading={index === 0 ? "eager" : "lazy"}
                    />
                  </MobileImageWrap>
                </SwiperSlide>
              ))}
            </Swiper>
          </Carousel>
        ) : (
          <ImageWrapper>
            <MissingProductImage
              role="presentation"
              fetchPriority="high"
              loading="eager"
            />
          </ImageWrapper>
        )}
      </MobileImagesContainer>
      <ImagesContainer layout={imageLinksList}>
        {imageLinksList && (
          <ThumbnailImageContainer>
            {imageLinksList?.map((image, index) => (
              <ImageWrap
                onClick={() => setPrimaryImage(index)}
                key={image}
                selectedImg={imageLinksList[primaryImage]}
                data-testid={`desktop-secondary-image-${index}`}
              >
                <SecondaryImage
                  src={image}
                  alt={accessoryColour.displayName}
                  fetchPriority="low"
                  loading="lazy"
                />
              </ImageWrap>
            ))}
          </ThumbnailImageContainer>
        )}
        <PrimaryImageContainer>
          {imageLinksList?.[primaryImage] || imageLinksList?.[0] ? (
            <PrimaryImage
              src={imageLinksList?.[primaryImage] || imageLinksList?.[0]}
              alt={accessoryColour.displayName}
              fetchPriority="high"
              loading="eager"
              data-testid="desktop-primary-image"
            />
          ) : (
            <ImageWrapper>
              <MissingProductImage
                role="presentation"
                fetchPriority="high"
                loading="eager"
              />
            </ImageWrapper>
          )}
        </PrimaryImageContainer>
      </ImagesContainer>
    </ImageGallery>
  );
};

export default ProductGallery;
